import qs from "qs";
import React, { useEffect, useState } from "react";
import "./styles.less";
import { blogAxios } from "../../utils/blogAxios";
import { useNavigate, useParams, Link } from "react-router-dom";
import { dateFormat } from "../../utils";
import ReactLoading from "react-loading";
import { useGlobalContext } from "../../context/global/context";
import Prism from "prismjs";

console.log(Prism.plugins);
// loadLanguages(["bash"]);

const READ_STORAGE_KEY = "_authing_read_blog_list";

const formatArticle = (content) => {
  console.log(content);
  return content
    .replace(/<.*?>/g, "")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">");
};

export const BlogDetailContent = (props) => {
  const { articleDetail, setArticleDetail } = props;
  const [article, setArticle] = useState(articleDetail);
  const [recommends, setRecommend] = useState([]);
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const { state } = useGlobalContext();

  useEffect(() => {
    setLoading(true);
    blogAxios
      .get(`/articles/${id}`)
      .then(({ data }) => {
        const readList = (localStorage.getItem(READ_STORAGE_KEY) || "").split(
          ","
        );
        if (!readList.includes(String(id))) {
          blogAxios.put(`/articles/${id}`, {
            readCount: (data.readCount || 0) + 1,
          });
          readList.push(id);
          localStorage.setItem(READ_STORAGE_KEY, readList.join(","));
          data.readCount++;
        }
        return data;
      })
      .then((data) => {
        setArticle(data);
        setArticleDetail(data);
        setLoading(false);
        Prism.highlightAll();
      });
  }, [id, setArticleDetail]);

  useEffect(() => {
    // formatArticle();
    if (article?.title) {
      document.title = `${article.title} - Authing 身份云 IDaaS 用户管理云服务，实现统一身份认证及单点登录`;
    }
  }, [article]);

  useEffect(() => {
    blogAxios.get("/recommends").then(({ data }) => {
      setRecommend(data);
    });
  }, []);

  const enterBlog = () => {
    nav("/blog");
  };

  return (
    <div className="blog-detail-content">
      <section className="article-navbar">
        <span className="item click-able" onClick={enterBlog}>
          博客
        </span>
        /
        <span
          onClick={() =>
            nav(
              `/blog?${qs.stringify({
                category: article?.category.id,
              })}`
            )
          }
          className="item click-able"
        >
          {article?.category && article?.category.name}
        </span>
        /<span className="item">{article?.title}</span>
        {/* <span className="item">开发者平台</span>/<span className="item">博客</span>/<span className="item">标签</span>/
        <span className="item">正文</span> */}
      </section>
      {loading ? (
        <div
          style={{
            minHeight: "calc(100vh - 160px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ReactLoading
            type="spinningBubbles"
            color="#215ae5"
            height={60}
            width={60}
          />
        </div>
      ) : (
        <section>
          <div className="article">
            <div className="article-title">{article?.title}</div>
            <div className="article-other">
              <span className="author">
                {article?.author?.username || "--"}
              </span>
              <span>
                {dateFormat(article?.publishedAt || article?.published_at)}
              </span>
              <span>阅读 {article?.readCount}</span>
              {state?.userInfo?.id === article?.user && (
                <Link to={`/blog/edit/${article?.id}`}>编辑</Link>
              )}
            </div>
            <div className="blog-article-content">
              <div dangerouslySetInnerHTML={{ __html: article?.content }}></div>
            </div>
          </div>
          {/* <div className="button-warp">
          <div className="blog-button primary" style={{ marginRight: 20 }}>
            <i className="icon authing-icon authing-caozuo"></i>点赞
          </div>
          <div className="blog-button default">
            <i className="icon authing-icon authing-caozuo"></i>分享
          </div>
        </div> */}
        </section>
      )}
      {Boolean(recommends?.length) && (
        <section className="realtion-article">
          <div className="realtion-article-title">推荐阅读</div>

          {recommends.map(({ article }, index) => {
            return (
              <Link
                to={`/blog/${article.id}`}
                key={index}
                className="realtion-article-item"
              >
                <div className="item-content-wrapper">
                  <div className="item-title">{article.title}</div>
                  <div className="item-content">
                    {/* {formatArticle(article.content)} */}
                  </div>
                  <div className="item-other">
                    <div className="author">
                      {article.author?.username || "--"}
                    </div>
                    <span className="split-dot">·</span>
                    <div className="time">
                      {dateFormat(article.publishedAt || article.published_at)}
                    </div>
                    <span className="split-dot">·</span>
                    <div className="views">{article.readCount || 0} 人阅读</div>
                    {/* <div className="author">{article.author?.username || "--"}</div>
                    <div className="time">{article.publishedAt}</div>
                    <div className="views">{article.readCount}</div> */}
                  </div>
                </div>
                {article.cover && (
                  <div
                    className="item-img"
                    style={{
                      backgroundImage: `url(${article.cover})`,
                    }}
                  ></div>
                )}
              </Link>
            );
          })}
        </section>
      )}
    </div>
  );
};
